$( document ).ready( function () {
    'use strict';

    const newdiv = "<div class='colorBar'></div>";
    $( '.postcards.cardset4 .kg-product-card-title-container' ).before( newdiv );

    $( '.postcards.cardset5 .kg-product-card-title-container' ).each( function ( index ){
        let stepdiv = document.createElement( 'div' )
        stepdiv.classList.add( 'stepBar' )
        stepdiv.innerHTML = "STEP " + ( Number( index ) + 1 )
        this.before( stepdiv );
    } );


    /**
     * Handle Load More posts button and Filters posts buttons.
     */
    const $blog_filters = $( '#blog-filters' ),
        $load_posts_button = $( '.load-more-button' ),
        $posts_container = $( '#blog_outer' );

    let current_archive_link = window.location.href,
        current_page = 1;

    // Maybe Show the Load More Button, only if there's more posts.
    maybe_show_load_more_button();

    // Get the link to the appropriate
    function get_archive_link( page ) {
        if ( page ) {
            return current_archive_link + `/page/${page}`;
        }

        return current_archive_link;
    }

    function show_loading_button() {
        $load_posts_button
            .text( pagination_loading_text )
            .removeClass( 'c_hidden' );
    }

    function maybe_show_load_more_button() {
        if ( ! $load_posts_button.length ) {
            return;
        }

        const available_pages_number = $( '[data-available-pages]' ).attr( 'data-available-pages' );

        $load_posts_button.text( pagination_more_posts_text );

        if ( current_page >= available_pages_number ) {
            $load_posts_button.addClass( 'c_hidden' );
        } else {
            $load_posts_button.removeClass( 'c_hidden' );
        }
    }

    // Handle Load More posts button.
    $load_posts_button.click( function ( e ){
        e.preventDefault();

        $.ajax({
            url: get_archive_link( current_page + 1 ),
            beforeSend: function () {
                show_loading_button();
            }
        } ).done( function ( data ) {
            $posts_container.append( $( data ).find( '#blog_inner' ) );
            current_page++;
            maybe_show_load_more_button();
        } );
    } );

    // Handle Filters posts buttons.
    $blog_filters.find( ' a' ).click( function ( e ){
        e.preventDefault();

        const $clicked_tag_element = $( e.target ),
            href = $clicked_tag_element.attr( 'href' );

        if ( '#back' === href ) {
            $blog_filters.removeClass( 'sub-nav-active' );
            return;
        }

        if ( -1 !== href.indexOf( '/insights' ) ) {
            $( '[data-sub-nav="insights"]' ).show();
            $blog_filters.addClass( 'sub-nav-active' );
        }

        if ( current_archive_link === href ) {
            return;
        }

        current_page = 1;
        current_archive_link = href;

        $blog_filters
            .find( ' .active' )
            .removeClass( 'active' );
        $clicked_tag_element.addClass( 'active' );

        $.ajax({
            url: get_archive_link( current_page ),
            beforeSend: function () {
                show_loading_button();
            }
        } ).done( function ( data ) {
            $posts_container.html( $( data ).find( '#blog_inner' ) );

            // Update the `available_pages_number` for the chosen tag - so we
            // know how many pages are available when the user clicks Load More.
            const available_pages_number = $( data ).find( '[data-available-pages]' ).attr( 'data-available-pages' );
            $( '[data-available-pages]' ).attr( 'data-available-pages', available_pages_number );

            maybe_show_load_more_button();
        } );
    } );

    // Handle Filters width for mobile by making the filters swipe-able.
    $( '.blog-filters-row' ).flickity( {
        contain: true,
        draggable: true,
        freeScroll: true,
        prevNextButtons: false,
        pageDots: false,
    } );


    /**
     * Enable the clicking of the anchor links in the Daily News Blog Posts Table of Contents.
     */
    $( '.news-table-of-contents a:not([href])' ).each( function ( index ){
        $( this ).attr( 'href', `#news-post-${ index+1 }` );
    } );
    $( '.news-item:not([id])' ).each( function ( index ){
        $( this ).attr( 'id', `news-post-${ index+1 }` );
    } );
} );
